import { eventTypes } from "./analytics";
import { getElementValue } from "./BrowserCommands";

const getHttpActionBody = async (httpRequest) => {
  if (!httpRequest.data) {
    // Data is a stringified json.
    return "";
  }
  const data = JSON.parse(httpRequest.data);
  for (const key of Object.keys(data)) {
    if (data[key]["browserCommand"]) {
      data[key] =
        (await getElementValue(
          window,
          JSON.parse(data[key]["browserCommand"])[0]
        )) || data[key];
    }
  }
  if (httpRequest.contentType.startsWith("application/x-www-form-urlencoded")) {
    return Object.keys(data).reduce(
      (current, key) => current + (current ? "&" : "") + `${key}=${data[key]}`,
      ""
    );
  } else if (httpRequest.contentType.startsWith("multipart/form-data")) {
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => formData.append(key, value));
    return formData;
  }
  return JSON.stringify(data);
};

export default async (httpRequest, sendEvent) => {
  if (httpRequest.runAtServer) {
    return;
  }

  try {
    if (process.env.REACT_APP_ENV === "production") {
      await fetch(httpRequest.url, {
        method: httpRequest.method,
        headers: {
          "Content-Type": httpRequest.contentType,
        },
        body: await getHttpActionBody(httpRequest),
      });
    } else {
      console.log("Sending ajax...", {
        url: httpRequest.method,
        headers: {
          "Content-Type": httpRequest.contentType,
        },
        body: await getHttpActionBody(httpRequest),
      });
    }
    if (sendEvent) {
      sendEvent(eventTypes.AJAX_ACTION, httpRequest);
    }
  } catch (e) {
    console.error(e);
  }
};
